export default "__VITE_ASSET__Boc72w7V__"